import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await login(email, password);
      if (r.user.role !== "admin") {
        toast.error("This is not an admin account.");
        return;
      }
      toast.success("Welcome, admin");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-navy text-bone flex items-center justify-center p-6">
      <div className="livery-stripe h-1 absolute top-0 left-0 right-0" />
      <form onSubmit={submit} className="w-full max-w-md bg-cream/5 border border-bone/10 rounded-lg p-8" data-testid="admin-login-form">
        <Link to="/" className="text-xs uppercase tracking-[0.2em] text-amber font-semibold">← Railway Careers UK</Link>
        <ShieldCheck className="w-10 h-10 text-amber mt-6" />
        <h1 className="font-display font-extrabold text-3xl tracking-tight mt-3">Admin sign-in</h1>
        <p className="text-bone/60 mt-2 text-sm">Internal access only.</p>
        <div className="mt-6 space-y-4">
          <div><Label className="text-bone/80">Email</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 bg-navy-700 border-bone/20 text-bone" data-testid="admin-login-email" /></div>
          <div><Label className="text-bone/80">Password</Label><Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 bg-navy-700 border-bone/20 text-bone" data-testid="admin-login-password" /></div>
          <Button type="submit" disabled={loading} className="w-full bg-amber text-ink hover:bg-amber-600 font-semibold" data-testid="admin-login-submit">{loading ? "Signing in…" : "Sign in"}</Button>
        </div>
      </form>
    </div>
  );
}
